import { createSlice } from '@reduxjs/toolkit';

interface IInitialState {
    showUserDisplay: boolean;
}

const initialState: IInitialState = {
    showUserDisplay: false,
};

const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState,
    reducers: {
        toggleUserDisplay: (state: IInitialState) => {
            state.showUserDisplay = !state.showUserDisplay;
        },

        closeUserDisplay: (state: IInitialState) => {
            state.showUserDisplay = false;
        },
    },
});

export default userProfileSlice.reducer;
export const { toggleUserDisplay, closeUserDisplay } = userProfileSlice.actions;
